import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import './RegistrationModal.css';

const RegistrationModal = ({ isOpen, onClose }) => {
  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = '';
    }
    return () => {
      document.body.style.overflow = '';
    };
  }, [isOpen]);

  return (
    <>
      {isOpen && (
        <div className="registration-modal-overlay" onClick={onClose}>
          <div className="registration-modal" onClick={(e) => e.stopPropagation()}>
            <div className="modal-body">
              <h1 className="modal-description">Select the type of account you want to create:</h1>
                          <div className="kbh-registration-grid">
              <div className="registration-option-card">
                <div className="option-icon">
                  <i className="fas fa-building"></i>
                </div>
                <h3>Organization Registration</h3>
                <p>
                  Register your organization to manage multiple schools and provide 
                  centralized access to KBH Classroom for your network.
                </p>
                <ul>
                  <li>Manage multiple schools</li>
                  <li>Centralized billing and administration</li>
                  <li>Bulk subscription management</li>
                  <li>Organization-wide reporting</li>
                </ul>
                <Link to="/register-org" className="btn btn-primary org-register-btn" onClick={onClose}>
                  Register as an Organization
                </Link>
              </div>
              <div className="registration-option-card">
                <div className="option-icon">
                  <i className="fas fa-school"></i>
                </div>
                <h3>School Registration</h3>
                <p>
                  Register your school to join an organization or as an independent. School secretaries and administrators
                  can register the school and manage multiple teachers.
                </p>
                <ul>
                  <li>Manage multiple teachers</li>
                  <li>Centralized school administration</li>
                  <li>Bulk student management</li>
                  <li>School-wide reporting</li>
                </ul>
                <Link to="/register" className="btn btn-primary" onClick={onClose}>
                  Register a School
                </Link>
              </div>
              <div className="registration-option-card">
                <div className="option-icon">
                  <i className="fas fa-chalkboard-teacher"></i>
                </div>
                <h3>Teacher Registration</h3>
                <p>
                  Register as a teacher to join an existing school. 
                  You'll get access to lesson materials and student management tools.
                </p>
                <ul>
                  <li>Join existing school with school code</li>
                  <li>Access to all lesson materials</li>
                  <li>Student management dashboard</li>
                  <li>Mission and Quiz creation and assignment</li>
                </ul>
                <Link to="/register/teacher" className="btn btn-primary" onClick={onClose}>
                  Register as a Teacher
                </Link>
              </div>
              {/* Student registration – hidden for now; remove class "student-registration-hidden" to show */}
              <div className="registration-option-card student-registration-hidden">
                <div className="option-icon">
                  <i className="fas fa-user-graduate"></i>
                </div>
                <h3>Student Registration</h3>
                <p>
                  Register as a student to join your teacher's class and access 
                  interactive learning materials and missions.
                </p>
                <ul>
                  <li>Join your teacher's class</li>
                  <li>Access interactive lessons</li>
                  <li>Complete missions and assignments</li>
                  <li>Track your progress</li>
                  <li>Build your knowledge</li>
                </ul>
                <Link to="/register/student" className="btn btn-primary" onClick={onClose}>
                  Register as a Student
                </Link>
              </div>
            </div>
            </div>
            <div className="modal-footer">
              <button className="btn btn-outline-secondary" onClick={onClose}>
                Cancel
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default RegistrationModal; 